import { UserProfile } from '@organization/api/requests'
import { Login, RestorePassword, TokenProfileGet } from '@organization/models'

import { ssoAxios } from './axios'

export const auth = {
  login: async (body: Login & { device_token?: string }) => {
    const { data } = await ssoAxios.post<UserProfile & TokenProfileGet>('/authorization/token/', body,{
     ...body?.device_token && {headers:{
      "Token": body.device_token
    }}
    })

    return data
  },

  restore: async (body: RestorePassword) => {
    const { data } = await ssoAxios.post<{ sended: boolean }>(
      '/authorization/user/restore/',
      body
    )

    return data
  },

  checkCookie: async () => {
    const { data } = await ssoAxios.get<UserProfile>('/authorization/token/cookie/')

    return data
  },

  logout: async () => {
    const { data } = await ssoAxios.get('/authorization/token/logout/')

    return data
  }
}
